import { jsx } from "react/jsx-runtime";
import React from "react";
import { Icon } from "@blueprintjs/core";
import ToolbarItem from "./ToolbarItem";
import { connectToEditor } from "../withEditorProps";
export default connectToEditor()(({
  toolbarItemProps,
  toggleViewVersionHistory
}) => {
  return /* @__PURE__ */ jsx(
    ToolbarItem,
    {
      ...{
        Icon: /* @__PURE__ */ jsx(Icon, { icon: "history" }),
        onIconClick: toggleViewVersionHistory,
        // disabled: hasBeenSaved || lastEdit,
        tooltip: /* @__PURE__ */ jsx("span", { children: "View Version History" }),
        ...toolbarItemProps
      }
    }
  );
});
